import styled from 'styled-components';

export default styled.span<{ large?: boolean }>`
  color: green;
  font-weight: 500;
  font-size: ${({ large }): string => (large ? '22px' : '16px')};
  line-height: 21px;
  font-family: 'futura-pt', sans-serif;
`;
